import { CORE_URL } from "@/constants/api";
import { VITE_CORE_API_URL } from "@/constants/env";
import { auth } from "@/services/auth-service";

export const getIntegrationConfig = async (): Promise<{
	username: string;
	password: string;
}> => {
	try {
		const response = await fetch(
			`${VITE_CORE_API_URL}${CORE_URL}/organization/self/integration-config`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${await auth?.currentUser?.getIdToken()}`,
					"Content-Type": "application/json",
				},
			},
		);

		if (!response.ok) {
			throw new Error(
				`Failed to fetch integration config: ${response.statusText}`,
			);
		}

		const responseData = await response.json();

		if (!responseData.success) {
			throw new Error(
				"Failed to fetch integration config: API returned unsuccessful response",
			);
		}

		// Extract username from the data field
		const username = responseData.data?.username || "";

		// Note: Password is not returned by the API for security reasons
		return {
			username,
			password: "", // Password will be handled separately
		};
	} catch (error) {
		console.error("Error in getIntegrationConfig:", error);
		throw error;
	}
};

export const checkServiceChannelConfig = async (): Promise<boolean> => {
	try {
		const response = await fetch(
			`${VITE_CORE_API_URL}${CORE_URL}/organization/self/has-service-channel-config`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${await auth?.currentUser?.getIdToken()}`,
					"Content-Type": "application/json",
				},
			},
		);

		if (!response.ok) {
			throw new Error(
				`Failed to check service channel config: ${response.statusText}`,
			);
		}

		const responseData = await response.json();

		if (!responseData.success) {
			throw new Error(
				"Failed to check service channel config: API returned unsuccessful response",
			);
		}

		return responseData.data?.hasConfig ?? false;
	} catch (error) {
		console.error("Error in checkServiceChannelConfig:", error);
		return false;
	}
};

export const getAssetTypeMappings = async (
	orgId: number,
): Promise<{
	facilityAIAssetTypes: Array<{
		id: number;
		name: string;
		categoryId: number;
		equipmentAreaId: number;
	}>;
	serviceChannelAssetTypes: Array<{
		id: number;
		name: string;
		trade: string;
	}>;
}> => {
	try {
		const response = await fetch(
			`${VITE_CORE_API_URL}${CORE_URL}/organization/asset-type-mappings/${orgId}`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${await auth?.currentUser?.getIdToken()}`,
					"Content-Type": "application/json",
				},
			},
		);

		if (!response.ok) {
			throw new Error(
				`Failed to fetch asset type mappings: ${response.statusText}`,
			);
		}

		const responseData = await response.json();

		if (!responseData.success) {
			throw new Error(
				"Failed to fetch asset type mappings: API returned unsuccessful response",
			);
		}

		return responseData.data;
	} catch (error) {
		console.error("Error in getAssetTypeMappings:", error);
		throw error;
	}
};
